import { useMemo } from "react";
import clsx from "clsx";
import { PageLayoutProps } from "@/shared/components/layout/PageLayout";
import { LexicalComposer } from "@lexical/react/LexicalComposer";

import { LEXICAL_COMPOSE_CONFIG } from "../../../config";
import { usePageLayout } from "@/app/hooks/usePageLayout";
import { EditorContextProvider } from "./EditorContextProvider";

interface EditorLayoutProps extends PageLayoutProps {
  children: React.ReactNode;
  isEditable: boolean;
}

export function EditorLayout({ children, className, isEditable, navbar, ...rest }: EditorLayoutProps) {
  const pageLayoutConfig = useMemo(
    () => ({ navbar, className: clsx("p-0!", className), resizeViewportOnKeyboardOpen: true, ...rest }),
    [navbar, className, rest]
  );
  usePageLayout(pageLayoutConfig);

  return (
    <LexicalComposer
      initialConfig={{
        ...LEXICAL_COMPOSE_CONFIG,
        namespace: "modal-editor",
        onError: () => {},
        editable: isEditable,
      }}
    >
      <EditorContextProvider>{children}</EditorContextProvider>
    </LexicalComposer>
  );
}
